export const ANALYTICS_SORT_TABLE = 'sortPeopleButton';
